const config = {
    name: 'Future Spin',
    language: 'da',

    mediaFolder: 'https://studievalg-danmark.euwest01.umbraco.io/media/',
    manifest: 'https://www.studievalg.dk/manifest.json'
}

/* change variables for local environment or cdn */
if (window.location.hostname === "localhost") {

}
else if (window.location.origin.includes('.azurewebsites.net') || window.location.origin.includes('.azureedge.net')) {
}



export default config